var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
/**
 * Internal button element for function key
 */
export var KeyButton = function (props) {
    return (_jsx("button", __assign({ className: classNames("fn_key prevent-select", {
            selected: !!props.selected,
        }), onClick: props.onClick, "aria-label": props.ariaLabel, "aria-pressed": props.selected }, { children: props.label })));
};
